import { apiSlice, publicApiSlice } from "../../apiSlice";
import { createProjectApi } from "./createProjectApi";

// Create both private and public API slices
export const projectApiSlice = createProjectApi(apiSlice);
export const publicProjectApiSlice = createProjectApi(publicApiSlice);

// Export hooks for private API
export const {
	useGetProjectByIdQuery,
	useLazyGetProjectByIdQuery,
	useGetProjectResultsQuery,
	useGetProjectResultsByGasQuery,
	useGetSOCrefQuery,
	useCreateProjectMutation,
	useUpdateProjectMutation,
	useDeleteProjectMutation,
	useCreateProjectCopyMutation,
	useGetProjectMembershipsQuery,
	useDeleteMembershipMutation,
	useGetProjectsQuery,
	useGetProjectsInfiniteInfiniteQuery,
	useUploadProjectAttachmentMutation,
	useDeleteProjectAttachmentMutation,
	useGetProjectAttachmentsQuery,
	useLazyDownloadProjectAttachmentQuery,
	useLazyGetMyMembershipsQuery,
	useLazyDownloadProjectReportQuery,
	useLazyExportProjectQuery,
	useFinalizeProjectMutation,
	useGetAllTagsQuery,
	useAddTagToProjectMutation,
	useDeleteTagFromProjectMutation,
	useGetTagsByProjectQuery,
	useMoveToTrashbinMutation,
	useUploadMapDataMutation,
	useTogglePublicProjectMutation,
	useGetProjectLockInfoQuery,
	useGetProjectTotalsQuery,
	useLazyGetProjectLockInfoQuery,
	useToggleProjectLockMutation,
	useCopyProjectAsyncMutation,
	useTriggerAsyncReportMutation,
	useGetReportTemplatesQuery,
	useImportProjectMutation,
	endpoints,
} = projectApiSlice;

// Export hooks for public API - only read operations
export const {
	useGetProjectByIdQuery: usePublicGetProjectByIdQuery,
	useLazyGetProjectByIdQuery: useLazyPublicGetProjectByIdQuery,
	useGetProjectResultsQuery: usePublicGetProjectResultsQuery,
	useGetProjectResultsByGasQuery: usePublicGetProjectResultsByGasQuery,
	useGetSOCrefQuery: usePublicGetSOCrefQuery,
	useGetProjectMembershipsQuery: usePublicGetProjectMembershipsQuery,
	useGetProjectsQuery: usePublicGetProjectsQuery,
	useGetProjectsInfiniteInfiniteQuery: usePublicGetProjectsInfiniteInfiniteQuery,
	useGetProjectAttachmentsQuery: usePublicGetProjectAttachmentsQuery,
	useLazyDownloadProjectAttachmentQuery: useLazyPublicDownloadProjectAttachmentQuery,
	useLazyGetMyMembershipsQuery: useLazyPublicGetMyMembershipsQuery,
	useLazyDownloadProjectReportQuery: useLazyPublicDownloadProjectReportQuery,
	useGetAllTagsQuery: usePublicGetAllTagsQuery,
	useGetTagsByProjectQuery: usePublicGetTagsByProjectQuery,
	useGetProjectLockInfoQuery: usePublicGetProjectLockInfoQuery,
	useGetProjectTotalsQuery: usePublicGetProjectTotalsQuery,
} = publicProjectApiSlice;
